import API from 'api';
import { PrintDataDetails, usePrintApi } from './usePrintApi';

export const usePrintDeliveryNoteReceived = () => {
  return usePrintApi({
    apiCall: ({ deliveryId = '' }: PrintDataDetails) => API.deliveries.getPrintDeliveryNoteReceived({ deliveryId }),
    deliveryId: undefined, // no initial load
  });
};

export default usePrintDeliveryNoteReceived;
